import _MinusIcon from "@adsk/alloy-react-icon/es/lib/MinusIcon";
import _CheckmarkIcon from "@adsk/alloy-react-icon/es/lib/CheckmarkIcon";
import _styled2 from "styled-components";
import _styled from "styled-components";
var _excluded = ["style", "className", "id", "name", "checked", "disabled", "defaultChecked", "onChange", "readOnly", "inputProps", "data-testid"],
    _excluded2 = ["style"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { useControlled, stylePropType } from '@adsk/alloy-react-helpers';
import theme, { getInteractiveStyles } from '@adsk/alloy-react-theme';
var CONTROL_SIZE = 16;
var CONTROL_BORDER_WIDTH = 1;
var CLICK_TARGET_SIZE = 20;
var CLICK_TARGET_OFFSET = (CONTROL_SIZE - CLICK_TARGET_SIZE) / 2;
var INDETERMINATE = 'indeterminate';
var CheckboxStates = [true, false, INDETERMINATE];

var mapStateToAriaChecked = function mapStateToAriaChecked(state) {
  if (state === INDETERMINATE) return 'mixed';
  return state;
};

var renderCheckmarkIcon = function renderCheckmarkIcon(p) {
  return /*#__PURE__*/React.createElement(_CheckmarkIcon, p);
};

var renderMinusIcon = function renderMinusIcon(p) {
  return /*#__PURE__*/React.createElement(_MinusIcon, p);
};

var mapStateToIconRenderer = function mapStateToIconRenderer(state) {
  if (state === true) return renderCheckmarkIcon;
  if (state === INDETERMINATE) return renderMinusIcon;
  return function () {
    return null;
  };
};

var checkIndeterminateState = function checkIndeterminateState(state) {
  // Expected behavior when using indeterminate checkbox state.
  if (state === INDETERMINATE) {
    return true;
  }

  return !state;
};

/**
 * A Checkbox
 * Provides a control to select from a list of non-exclusive options.
 * Checking the box should enable or select the active state.
 * (Don't phrase check boxes with a negative and require checking a box to turn something off.)
 * The rest of the props are propogated to the input element.
 */
var Checkbox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var style = _ref.style,
      className = _ref.className,
      id = _ref.id,
      name = _ref.name,
      checked = _ref.checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$defaultChecked = _ref.defaultChecked,
      defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
      onChangeProp = _ref.onChange,
      readOnly = _ref.readOnly,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      dataTestid = _ref['data-testid'],
      props = _objectWithoutProperties(_ref, _excluded);

  var _useControlled = useControlled(defaultChecked, checked, onChangeProp),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      handleOnChange = _useControlled2[1];

  var onChangeWrapper = function onChangeWrapper(e) {
    return handleOnChange(checkIndeterminateState(value), e);
  };

  var onChange = readOnly ? undefined : function (e) {
    !disabled && onChangeWrapper(e);
  };
  var notUnchecked = value !== false;

  var inputStyle = inputProps.style,
      rest = _objectWithoutProperties(inputProps, _excluded2);

  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    role: "checkbox",
    "aria-checked": mapStateToAriaChecked(value),
    className: className
  }, props, {
    $_css: [_objectSpread(_objectSpread(_objectSpread({
      display: 'block',
      height: CONTROL_SIZE,
      width: CONTROL_SIZE,
      borderWidth: notUnchecked ? 0 : CONTROL_BORDER_WIDTH,
      borderStyle: 'solid',
      borderRadius: 2,
      borderColor: theme.colors.charcoal400,
      backgroundColor: notUnchecked ? theme.colors.adskBlue500 : 'inherit',
      cursor: 'pointer',
      color: theme.colors.white
    }, getInteractiveStyles(disabled)), disabled && {
      backgroundColor: notUnchecked ? theme.colors.charcoal100 : 'inherit',
      borderColor: theme.colors.charcoal200,
      color: theme.colors.charcoal400
    }), {}, {
      '& svg': {
        display: 'block'
      }
    }), style]
  }), notUnchecked && mapStateToIconRenderer(value)({
    size: CONTROL_SIZE
  }), /*#__PURE__*/React.createElement(_StyledInput, _extends({
    ref: ref,
    id: id,
    name: name,
    value: value.toString(),
    type: "checkbox",
    onChange: onChange,
    readOnly: readOnly,
    checked: !!value,
    disabled: disabled,
    "data-testid": dataTestid
  }, rest, {
    $_css2: [{
      appearance: 'none',
      cursor: 'inherit',
      display: 'block',
      position: 'relative',
      opacity: 0,
      width: CLICK_TARGET_SIZE,
      height: CLICK_TARGET_SIZE,
      top: notUnchecked ? CLICK_TARGET_OFFSET - CONTROL_SIZE : CLICK_TARGET_OFFSET - CONTROL_BORDER_WIDTH,
      left: notUnchecked ? CLICK_TARGET_OFFSET : CLICK_TARGET_OFFSET - CONTROL_BORDER_WIDTH,
      margin: 0,
      padding: 0
    }, _objectSpread({}, inputStyle)]
  })));
});
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,

  /** Class applied to the root element */
  className: PropTypes.string,

  /** The id of the checkbox, used for the label */
  id: PropTypes.string,

  /** The name for the checkbox input */
  name: PropTypes.string,

  /** The value of the checkbox */
  checked: PropTypes.oneOf(CheckboxStates),

  /** The initial value of the checkbox, this will be read only if `checked` is undefined */
  defaultChecked: PropTypes.oneOf(CheckboxStates),

  /** onChange handler for the checkbox input */
  onChange: PropTypes.func,

  /** Disables propagation stop */
  readOnly: PropTypes.bool,

  /** Disable checkbox functionallity */
  disabled: PropTypes.bool,

  /** Props passed to the input element */
  inputProps: PropTypes.object,

  /** data-testid passed to the input element */
  'data-testid': PropTypes.string
};
export default Object.assign(Checkbox, {
  INDETERMINATE: INDETERMINATE
});

var _StyledDiv = _styled("div").withConfig({
  displayName: "Checkbox___StyledDiv",
  componentId: "sc-15wa5w9-0"
})(["", ""], function (p) {
  return p.$_css;
});

var _StyledInput = _styled("input").withConfig({
  displayName: "Checkbox___StyledInput",
  componentId: "sc-15wa5w9-1"
})(["", ""], function (p) {
  return p.$_css2;
});
//# sourceMappingURL=Checkbox.js.map